/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_ApprovingInputs */

const en_samples_approving = /** @type {(inputs: Samples_ApprovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approving...`)
};

const es_samples_approving = /** @type {(inputs: Samples_ApprovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprobando...`)
};

/**
* | output |
* | --- |
* | "Approving..." |
*
* @param {Samples_ApprovingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_approving = /** @type {((inputs?: Samples_ApprovingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_ApprovingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_approving(inputs)
	return es_samples_approving(inputs)
});